import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { usePushNotificationApi } from '../../hooks/usePushNotificationApi';



export const UseCreatePushNotification = () => {
  const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createPushNotification } = usePushNotificationApi();
  return useMutation({
    mutationKey: ['CreatePushNotification'],
    mutationFn: ({ modifiedValues }: { modifiedValues: any}) => {
      return createPushNotification(modifiedValues);
    },
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Push Notification created successfully',
        'success'
      );
      queryClient.invalidateQueries({
        queryKey: ['PushNotification'],
        exact: false,
      });
    },
    onError: (error: any) => {
      showMessage(
        error.response?.data?.message || 'Failed to create Push Notification',
        'error'
      );
    },
  });
};


